import Ingest from './ingest/ingest.vue'
import IngestACL from './ingest/ingest-acl.vue'

const __default__ = {
  data() {
    return {
      active: 'ingest',
    }
  },
  computed: {
    tabs() {
      return [
        {value: 'ingest', title: 'Ingest External'},
        {value: 'ingest-acl', title: 'Ingest Internal'},
      ]
    } 
  },
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'ingest',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { Ingest, IngestACL }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})